import React from "react";
import { Link } from "react-router-dom";
import Button from "../SelectValue/Button";
import {
  format,
  addMonths,
  differenceInDays,
  differenceInWeeks,
  differenceInMonths,
} from "date-fns";

function SavingSummary() {
  const amount = sessionStorage.getItem("savingsAmount");
  const name = sessionStorage.getItem("savingsName");
  const fre = sessionStorage.getItem("savingsFre");
  const duration = sessionStorage.getItem("savingDuration");
  const startDate = sessionStorage.getItem("startDate");

  const start = startDate ? new Date(startDate) : new Date();

  const getMonthsFromDuration = (dur) => {
    switch (dur) {
      case "MONTHLY":
        return 1;
      case "THREE_MONTH":
        return 3;
      case "SIX_MONTH":
        return 6;
      case "NINE_MONTH":
        return 9;
      case "ONE_YEAR":
        return 12;

      default:
        return parseInt(dur) || 0;
    }
  };
  const end = addMonths(start, getMonthsFromDuration(duration));

  const baseAmount = Number(amount?.toString().replace(/,/g, "")) || 0;
  let calculatedTargetAmount = baseAmount;
  const upperFre = fre ? fre.toUpperCase() : "";
  if (upperFre === "DAILY") {
    calculatedTargetAmount = baseAmount * differenceInDays(end, start);
  } else if (upperFre === "WEEKLY") {
    calculatedTargetAmount = baseAmount * differenceInWeeks(end, start);
  } else if (upperFre === "MONTHLY") {
    calculatedTargetAmount = baseAmount * differenceInMonths(end, start);
  }
  const displayTargetAmount =
    calculatedTargetAmount > 0
      ? calculatedTargetAmount.toLocaleString()
      : amount;

  const formattedStart = format(start, "dd MMM, yyyy");
  const formattedEnd = format(end, "dd MMM, yyyy");

  return (
    <div>
      <div className="h-[60vh] mt-4">
        <h1 className=" text-back-color2 text-[18px] mb-2 font-[500]">
          Summary
        </h1>
        <div className=" my-4 flex justify-between">
          <div>
            <p className=" text-[15px] text-primary-color6 mb-1 uppercase">
              Goal Name
            </p>
            <p className=" text-back-color2 md:text-[18px] font-[500] ">
              {name}
            </p>
          </div>
          <div>
            <p className=" text-[14px] text-primary-color6 mb-1 uppercase">
              Target Amount
            </p>
            <p className=" text-back-color2 md:text-[18px] font-[500] text-end">
              NGN {displayTargetAmount}
            </p>
          </div>
        </div>
        <div className=" my-4 flex justify-between">
          <div>
            <p className=" text-[14px] text-primary-color6 mb-1 uppercase">
              Frequency
            </p>
            <p className=" text-back-color2 md:text-[18px] font-[500] capitalize">
              {fre}
            </p>
          </div>
          <div>
            <p className=" text-[14px] text-primary-color6 mb-1 uppercase">
              Payment Method
            </p>
            <div className=" flex items-center gap-2">
              <p className=" text-back-color2 md:text-[18px] font-[500] text-end">
                {(() => {
                  const method = sessionStorage.getItem("paymentMethod");
                  if (method === "CARD") {
                    try {
                      const card = JSON.parse(sessionStorage.getItem("selectedCard"));
                      return card ? `Card (**** ${card.last4})` : "Card";
                    } catch (e) {
                      return "Card";
                    }
                  }
                  return method ? method.charAt(0).toUpperCase() + method.slice(1).toLowerCase() : "Wallet";
                })()}
              </p>
              <Link to="/save/plan/createpayment">
                <span className=" px-2 py-0.5 text-white text-[12px] rounded-[32px] bg-[#F7941D] cursor-pointer">
                  Change
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className=" my-4 flex justify-between">
          <div>
            <p className=" text-[14px] text-primary-color6 mb-1 uppercase">
              Start Date
            </p>
            <p className=" text-back-color2 md:text-[18px] font-[500] uppercase">
              {formattedStart}
            </p>
          </div>
          <div>
            <p className=" text-[14px] text-primary-color6 mb-1 uppercase">
              End Date
            </p>
            <p className=" text-back-color2 md:text-[18px] font-[500] text-end uppercase">
              {formattedEnd}
            </p>
          </div>
        </div>
        <Link to="/save/plan/payment">
          <div className=" grid grid-cols-1 mt-16">
            <Button name="Confirm" />
          </div>
        </Link>
      </div>
    </div>
  );
}

export default SavingSummary;
